import React, { useState, useEffect } from "react";
import MyItemListView from "presentational/portfolio/MyItemListView";
import GenderFillModalView from "presentational/common/GenderFillModal/GenderFillModalView";
import { withToken } from "lib/forceTokenRenewComponent";
import { withStore } from "store/storeHandler";
import TXT from "presentational/common/multinational/TXT";
import { useHistory } from "react-router-dom";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

MyItemList.propTypes = {
  onItemUploadClick: PropTypes.func.isRequired
};

function MyItemList(props) {
  const {
    onItemUploadClick,
    catListOfMine,
    itemList,
    nowCategory,
    isLoading,
    isEnd,
    myGenderFilled,
    myProfile,
    forceRenewTokenWT,
    NoticeModalActions,
    MyItemActions,
    AppErrorActions,
    ItemDetailActions,
    UserProfileActions,
    getIdTokenWT
  } = props;

  const [itemDeleteMode, setItemDeleteMode] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [needGenderFillModal, setNeedGenderFillModal] = useState(false);

  const history = useHistory();

  useEffect(() => {
    initList();
  }, []);
  useEffect(() => {
    checkNeedGenderInput();
  }, [myGenderFilled, itemList]);

  const initList = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyItemActions.initItemList(idToken);
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  };

  const checkNeedGenderInput = () => {
    if (itemList.length > 0 && myGenderFilled === "genderUnset") {
      setNeedGenderFillModal(true);
    }
  };

  const getChangedItemList = async (category, forceUpdate) => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyItemActions.changeItemList({ category, forceUpdate, idToken });
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  };

  const submitGenderInfo = async selectedGender => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await UserProfileActions.registerMyGender({ selectedGender, idToken });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const HandleNextItemListRequest = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyItemActions.getList(idToken);
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  };

  const handleDropdownSelect = async (key, category) => {
    await getChangedItemList(category);
  };

  const handleItemDeleteModeChange = ({ itemDeleteMode }) => {
    setItemDeleteMode(itemDeleteMode);
  };

  const handleItemDeleteSubmit = async itemHash => {
    const hasSucceed = await forceRenewTokenWT();
    if (!hasSucceed) return null;

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    if (isDeleting) return null;

    await setIsDeleting(true);

    try {
      try {
        const code = await MyItemActions.removeItem({ itemHash, idToken });
        if (code === "UnknownItem") {
          NoticeModalActions.openModal({
            content: <TXT name="msg_commonNetworkError" />
          });
        }
      } catch (error) {
        NoticeModalActions.openModal({
          content: <TXT name="msg_commonNetworkError" />
        });
        AppErrorActions.setSafeAppError(error);
        setItemDeleteMode(false);
        setIsDeleting(false);
        return null;
      }

      setItemDeleteMode(false);
      setIsDeleting(false);
      MyItemActions.setRealtimeDataOnNextRequest();
      await getChangedItemList(nowCategory, true);
    } catch (error) {
      console.log("error", error);
      console.error("error", error);
    }
  };

  const handleItemClick = itemInfo => {
    ItemDetailActions.initItemInfo(itemInfo);
    history.push(getEssentialUrl({ type: "itemDetail" })(itemInfo.itemHash));
  };

  const handleSubmit = async selectedGender => {
    await submitGenderInfo(selectedGender);
    await setNeedGenderFillModal(false);
  };

  return (
    <div>
      <MyItemListView
        preset={myProfile.preset}
        catListOfMine={catListOfMine}
        selectedCategory={nowCategory}
        itemList={itemList}
        isItemListLoading={isLoading}
        isItemListEnd={isEnd}
        itemDeleteMode={itemDeleteMode}
        onItemDeleteModeChange={handleItemDeleteModeChange}
        onDropdownSelect={handleDropdownSelect}
        onNextItemListRequest={HandleNextItemListRequest}
        onItemDeleteSubmit={handleItemDeleteSubmit}
        onItemUploadClick={onItemUploadClick}
        onItemClick={handleItemClick}
      />
      <GenderFillModalView
        needGenderFillModal={needGenderFillModal}
        onSubmit={handleSubmit}
      />
    </div>
  );
}

export default withStore({
  stateMap: {
    myItem: ["itemList", "nowCategory", "isLoading", "catListOfMine", "isEnd"],
    userProfile: ["myGenderFilled", "myProfile"]
  },
  dispatchMap: [
    "myItem",
    "appError",
    "noticeModal",
    "itemDetail",
    "userProfile"
  ]
})(withToken(MyItemList));
